import React from 'react';
import { BatchErrorMessages } from './BatchErrorMessages/BatchErrorMessages';
import { errorTag } from 'utilities/uTagging';
import { PATH_ERROR } from 'constants/uTagConstants/paths';
import { wayCountriesNotSpain } from 'utilities/logicByCountry';
import { StandByHC } from 'components/newAccountSteps/profileSteps/standByHC';
import { CountriesNotSpainView } from './CountriesNotSpainView/CountriesNotSpainView';
import { ProfileView } from './ProfileView/ProfileView';

export const ProfessionalDataView = ({
    errorState,
    immJointHoldersStatus,
    immStandByState,
    preLoaderActions,
    products,
    userProfile,
}) => {
    const shouldShowStandByJointHolderView = immStandByState.get('showStandByJointHolderView');
    const hasBatchError = errorState.batchError;

    if (hasBatchError) {
        preLoaderActions.hidePreLoader();
        errorTag('', PATH_ERROR);

        return <BatchErrorMessages />;
    }

    if (wayCountriesNotSpain()) {
        return <CountriesNotSpainView products={products} status={userProfile.status} />;
    }

    return (
        <div className="basic-layering">
            {!shouldShowStandByJointHolderView ? (
                <ProfileView
                    fetchSuccess={immJointHoldersStatus.get('fetchSuccess')}
                    products={products}
                    status={userProfile.status}
                    jointHolderType={userProfile.jointHolderType}
                    showOpenCredit={userProfile.showOpenCredit}
                />
            ) : (
                <StandByHC />
            )}
        </div>
    );
};
